// extracted by mini-css-extract-plugin
module.exports = {"avatar_wrapper":"avatar_avatar_wrapper__2PSoX","small":"avatar_small__2whKK","large":"avatar_large__1tB2-"};